import { lazy, Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { PackageGate } from '@/components/auth/PackageGate';
import { AuthLoadingFallback } from '@/components/auth/ProtectedRoute';
import { certSlugToFeId, feCertIdToPackageCode } from '@/lib/certificationType';

const PreAssessment = lazy(() => import('@/pages/PreAssessment'));

/**
 * Scoped pre-assessment: URL implies certification; enforces package entitlement.
 */
export function PreAssessmentRoute() {
  const { certSlug } = useParams();
  const feId = certSlugToFeId(certSlug);
  if (!feId) {
    return <Navigate to="/dashboard" replace />;
  }
  const code = feCertIdToPackageCode(feId);
  return (
    <PackageGate code={code}>
      <Suspense fallback={<AuthLoadingFallback />}>
        <PreAssessment />
      </Suspense>
    </PackageGate>
  );
}
